import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=20de2571&"
import script from "./HomeView.vue?vue&type=script&lang=js&"
export * from "./HomeView.vue?vue&type=script&lang=js&"
import style0 from "./HomeView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports